import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { PublishedConnectionContentType } from '~src/spacesPlatform/models/ContentTypes';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { launchRevisionHistory } from '../../../../revisionHistory/actions/RevisionHistoryAction';
import { IRevisionHistoryAction } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsUnpublishedWorkbook, isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const RevisionHistoryEntityAction: IEntityAction<IContentInfo, IRevisionHistoryAction> = {
  name: EntityActionNames.RevisionHistory,
  translateName: Messages.revisionHistory_action,
  isVisible: (targetItems: IContentInfo[], appState: AppState) => {
    if (anyItemIsUnpublishedWorkbook(targetItems)) {
      return false;
    }

    return SessionSiteSelectors.isVersioningEnabled(appState) && !isSingleEmbeddedDatasource(targetItems) && (targetItems[0].contentType === PublishedConnectionContentType.name ? FeatureFlags.vconnRevisionHistoryEnabled : true);
  },
  isClickable: (availableActions: IRevisionHistoryAction) => availableActions && availableActions.versionManagement,
  createReduxAction: (targetItems: IContentInfo[]) => launchRevisionHistory(targetItems[0])
};
